import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createSwapEffectApi, storeSwapEffectApi } from './swapEffectSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import SwapEffectForm from './SwapEffectForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function SwapEffectCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialValuess = {
        description: '',
    };

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeSwapEffectApi({ navigate, values }));
    };

    return (
        <SwapEffectForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValuess}
            formSubmit={formSubmit}
        />
    );
}

export default SwapEffectCreate;
